<template>
  <div class="home">
    <Navbar id="navbar"></Navbar>
    <div id="pagebody" class="container">
      <Trans id="trans"></Trans>
    </div>
  </div>
</template>

<script>

import firebase from 'firebase/app'
require('@firebase/auth');
require('@firebase/database');
require('@firebase/firestore');
require('@firebase/functions');
require('@firebase/messaging');
require('@firebase/storage');
require('@firebase/performance');
import HelloWorld from '@/components/HelloWorld.vue'
import Navbar from '@/components/Navbar'
import Trans from '@/components/Trans'


export default {
  name: 'transactions',
  components: {
    HelloWorld,
    Navbar,
    Trans
  },
  methods:{
    logout: function(){
      firebase.auth().signOut().then(() => {
        this.$router.replace('login')
      })
    }
  }
}
</script>

<style>

#navbar {
  margin-bottom: 80px;
}

</style>
